import { render, staticRenderFns } from "./MStoreUnsupportedInput.vue?vue&type=template&id=36473f10&"
import script from "./MStoreUnsupportedInput.vue?vue&type=script&lang=ts&"
export * from "./MStoreUnsupportedInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports